import React, {type FC} from 'react'
import {Modal, type ModalProps} from 'uikit'
import {useAppSelector} from 'store'
import {getStatusModal} from 'store/modal/selectors'

type Props = Omit<ModalProps, 'status'>

export const ModalWrap: FC<Props> = (props) => {
  const status = useAppSelector(getStatusModal)

  return <Modal status={status} {...props} />
}
